export { Legal, LegalVariant } from './legal';
export type { LegalProps } from './legal';
export {LegalInterface} from './legal.interface';